export enum LoginAccessType {
  'Self' = 0,
  'Entity-Wide' = 1,
  'Global' = 2
}
